var _circle, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloseWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#EEF2F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.3713,
    y: 36.7012,
    width: 29.4869,
    height: 3.21423,
    rx: 1.60711,
    transform: "rotate(-44.3376 15.3713 36.7012)",
    fill: "#808080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1363 17.1364C16.7639 16.5088 17.7815 16.5088 18.4091 17.1364L36.8486 35.5759C37.4762 36.2035 37.4762 37.221 36.8486 37.8487C36.221 38.4763 35.2034 38.4763 34.5758 37.8487L16.1363 19.4092C15.5087 18.7816 15.5087 17.764 16.1363 17.1364Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseWhite);
export default __webpack_public_path__ + "static/media/Icon_Close_White.ee5fa84720121940a6b2962d51eb6372.svg";
export { ForwardRef as ReactComponent };